import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ru: {
    translation: {
      nav: {
        home: "Главная",
        collection: "Коллекция",
        about: "О нас",
        reviews: "Отзывы",
        order: "Заказ/Осмотр",
        contacts: "Контакты",
        phone: "+371 28448991",
        tagline: "custom fine jewelry & engagement rings"
      },
      hero: {
        title: "Pure Atelier Riga",
        subtitle: "Fine Jewelry & Engagement Rings",
        description: "Эксклюзивная коллекция ювелирных изделий для особенных моментов. Каждое украшение — это история любви, воплощённая в драгоценных камнях.",
        viewCollection: "Смотреть коллекцию",
        contact: "Связаться с нами"
      },
      categories: {
        title: "Наши коллекции",
        description: "Откройте для себя мир изысканных украшений, созданных для самых важных моментов вашей жизни",
        rings: "Помолвочные кольца",
        ringsDesc: "Символ вечной любви",
        earrings: "Серьги-пусеты",
        earringsDesc: "Элегантность в деталях",
        bracelets: "Эксклюзивные браслеты",
        braceletsDesc: "Роскошь на запястье"
      },
      featured: {
        title: "Избранные изделия",
        description: "Самые популярные украшения из нашей коллекции",
        viewAll: "Смотреть все изделия"
      },
      about: {
        title: "О Pure Atelier",
        p1: "Мы создаём украшения, которые рассказывают истории. Каждое изделие в нашей коллекции — это результат кропотливой работы мастеров и тщательного отбора драгоценных камней.",
        p2: "От помолвочных колец до эксклюзивных браслетов — мы помогаем вам найти идеальное украшение для самых важных моментов жизни.",
        bookViewing: "Записаться на просмотр"
      },
      gallery: {
        title: "Коллекция",
        description: "Откройте для себя наши эксклюзивные ювелирные изделия",
        all: "Все",
        sort: "Сортировка",
        popularity: "По популярности",
        priceAsc: "Цена: по возрастанию",
        priceDesc: "Цена: по убыванию",
        loading: "Загрузка...",
        noProducts: "Изделия не найдены"
      },
      product: {
        back: "Назад к коллекции",
        popular: "Популярное изделие",
        characteristics: "Характеристики",
        category: "Категория",
        sku: "Артикул",
        inquire: "Запросить информацию",
        call: "Позвонить",
        deliveryTitle: "Информация о доставке",
        deliveryText: "Мы обеспечиваем безопасную доставку по всей Латвии и Европе. Каждое изделие упаковывается в роскошную фирменную упаковку. Для получения подробной информации, пожалуйста, свяжитесь с нами.",
        notFound: "Изделие не найдено"
      },
      contact: {
        title: "Свяжитесь с нами",
        name: "Имя",
        phone: "Телефон",
        email: "Email",
        message: "Сообщение",
        submit: "Отправить",
        sending: "Отправка...",
        success: "Спасибо! Мы свяжемся с вами в ближайшее время.",
        error: "Произошла ошибка. Пожалуйста, попробуйте позже.",
        interested: "Здравствуйте! Интересует изделие:"
      },
      admin: {
        login: "Вход в админ-панель",
        username: "Имя пользователя",
        password: "Пароль",
        loginButton: "Войти",
        logout: "Выйти",
        dashboard: "Панель управления",
        products: "Товары",
        contacts: "Заявки",
        reviews: "Отзывы",
        content: "Контент",
        marketing: "Маркетинг",
        settings: "Настройки",
        totalProducts: "Всего товаров",
        totalContacts: "Всего заявок",
        recentContacts: "Недавние заявки",
        addProduct: "Добавить товар",
        editProduct: "Редактировать товар",
        deleteProduct: "Удалить товар",
        save: "Сохранить",
        cancel: "Отмена",
        delete: "Удалить",
        nameRu: "Название (RU)",
        nameLv: "Название (LV)",
        descRu: "Описание (RU)",
        descLv: "Описание (LV)",
        price: "Цена (€)",
        category: "Категория",
        images: "Изображения",
        popularity: "Популярность",
        uploadImage: "Загрузить изображение",
        actions: "Действия",
        edit: "Редактировать",
        view: "Просмотр",
        product: "Товар",
        date: "Дата",
        confirmDelete: "Вы уверены, что хотите удалить этот товар?"
      },
      reviews: {
        title: "Отзывы клиентов",
        averageRating: "Средняя оценка",
        basedOn: "На основе",
        reviewsCount: "отзывов",
        leaveReview: "Оставить отзыв",
        yourName: "Ваше имя",
        yourEmail: "Ваш email",
        rating: "Оценка",
        yourReview: "Ваш отзыв",
        submit: "Отправить",
        success: "Спасибо за ваш отзыв! Он будет опубликован после модерации.",
        error: "Произошла ошибка. Пожалуйста, попробуйте позже."
      }
    }
  },
  lv: {
    translation: {
      nav: {
        home: "Sākums",
        collection: "Kolekcija",
        about: "Par mums",
        reviews: "Atsauksmes",
        order: "Pasūtījums",
        contacts: "Kontakti",
        phone: "+371 28448991",
        tagline: "custom fine jewelry & engagement rings"
      },
      hero: {
        title: "Pure Atelier Riga",
        subtitle: "Fine Jewelry & Engagement Rings",
        description: "Ekskluzīva juvelierizstrādājumu kolekcija īpašiem brīžiem. Katra rotaslieta ir mīlestības stāsts, kas iemiesots dārgakmeņos.",
        viewCollection: "Skatīt kolekciju",
        contact: "Sazināties ar mums"
      },
      categories: {
        title: "Mūsu kolekcijas",
        description: "Atklājiet izsmalcinātu juvelierizstrādājumu pasauli, kas radīta jūsu dzīves svarīgākajiem brīžiem",
        rings: "Saderināšanās gredzeni",
        ringsDesc: "Mūžīgās mīlestības simbols",
        earrings: "Auskari",
        earringsDesc: "Elegance detaļās",
        bracelets: "Ekskluzīvas aproces",
        braceletsDesc: "Greznība uz rokas"
      },
      featured: {
        title: "Izlases izstrādājumi",
        description: "Populārākās rotaslietas no mūsu kolekcijas",
        viewAll: "Skatīt visus izstrādājumus"
      },
      about: {
        title: "Par Pure Atelier",
        p1: "Mēs radām juvelierizstrādājumus, kas stāsta stāstus. Katrs izstrādājums mūsu kolekcijā ir rūpīga meistaru darba un rūpīgas dārgakmeņu atlases rezultāts.",
        p2: "No saderināšanās gredzeniem līdz ekskluzīvām aprocēm — mēs palīdzam jums atrast ideālo rotaslietu jūsu dzīves svarīgākajiem brīžiem.",
        bookViewing: "Pieteikties apskatei"
      },
      gallery: {
        title: "Kolekcija",
        description: "Atklājiet mūsu ekskluzīvos juvelierizstrādājumus",
        all: "Visi",
        sort: "Kārtot",
        popularity: "Pēc popularitātes",
        priceAsc: "Cena: augoša",
        priceDesc: "Cena: dilstoša",
        loading: "Ielādē...",
        noProducts: "Izstrādājumi nav atrasti"
      },
      product: {
        back: "Atpakaļ uz kolekciju",
        popular: "Populārs izstrādājums",
        characteristics: "Raksturojums",
        category: "Kategorija",
        sku: "Artikuls",
        inquire: "Pieprasīt informāciju",
        call: "Zvanīt",
        deliveryTitle: "Piegādes informācija",
        deliveryText: "Mēs nodrošinām drošu piegādi visā Latvijā un Eiropā. Katrs izstrādājums tiek iepakots greznā zīmola iepakojumā. Lai iegūtu detalizētu informāciju, lūdzu, sazinieties ar mums.",
        notFound: "Izstrādājums nav atrasts"
      },
      contact: {
        title: "Sazināties ar mums",
        name: "Vārds",
        phone: "Tālrunis",
        email: "E-pasts",
        message: "Ziņojums",
        submit: "Nosūtīt",
        sending: "Sūta...",
        success: "Paldies! Mēs ar jums sazināsimies tuvākajā laikā.",
        error: "Radās kļūda. Lūdzu, mēģiniet vēlreiz.",
        interested: "Sveiki! Interesē izstrādājums:"
      },
      admin: {
        login: "Ieiet admin panelī",
        username: "Lietotājvārds",
        password: "Parole",
        loginButton: "Ieiet",
        logout: "Iziet",
        dashboard: "Panelis",
        products: "Produkti",
        contacts: "Pieteikumi",
        reviews: "Atsauksmes",
        content: "Saturs",
        marketing: "Mārketings",
        settings: "Iestatījumi",
        totalProducts: "Kopā produktu",
        totalContacts: "Kopā pieteikumu",
        recentContacts: "Nesenie pieteikumi",
        addProduct: "Pievienot produktu",
        editProduct: "Rediģēt produktu",
        deleteProduct: "Dzēst produktu",
        save: "Saglabāt",
        cancel: "Atcelt",
        delete: "Dzēst",
        nameRu: "Nosaukums (RU)",
        nameLv: "Nosaukums (LV)",
        descRu: "Apraksts (RU)",
        descLv: "Apraksts (LV)",
        price: "Cena (€)",
        category: "Kategorija",
        images: "Attēli",
        popularity: "Popularitāte",
        uploadImage: "Augšupielādēt attēlu",
        actions: "Darbības",
        edit: "Rediģēt",
        view: "Skatīt",
        product: "Produkts",
        date: "Datums",
        confirmDelete: "Vai tiešām vēlaties dzēst šo produktu?"
      },
      reviews: {
        title: "Klientu atsauksmes",
        averageRating: "Vidējais vērtējums",
        basedOn: "Balstīts uz",
        reviewsCount: "atsauksmēm",
        leaveReview: "Atstāt atsauksmi",
        yourName: "Jūsu vārds",
        yourEmail: "Jūsu e-pasts",
        rating: "Vērtējums",
        yourReview: "Jūsu atsauksme",
        submit: "Nosūtīt",
        success: "Paldies par jūsu atsauksmi! Tā tiks publicēta pēc moderācijas.",
        error: "Radās kļūda. Lūdzu, mēģiniet vēlreiz."
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'lv',
    lng: 'lv',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
